// arXiv 相关外链工具。

// 谷歌网页全文翻译：代理翻译 arXiv HTML 版整页为中文。
export function googleZhUrl(arxivId) {
  const html = `https://arxiv.org/html/${arxivId}`;
  return `https://translate.google.com/translate?hl=zh-CN&sl=en&tl=zh-CN&u=${encodeURIComponent(html)}`;
}

export function arxivHtmlUrl(arxivId) {
  return `https://arxiv.org/html/${arxivId}`;
}
